import { mergeDeepRight, prop } from 'ramda';
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

const defaultConfig = {
    lng: 'en',
    fallbackLng: 'en',
    fallbackNS: 'common'
};

const buildConfig = (modules = [], config = {}) => {
    i18next.init({
        ...defaultConfig,
        ...config,
        resources: modules.reduce(
            (acc, m) => mergeDeepRight(acc, m.resources),
            {}
        ),
        ns: modules.map(prop('ns'))
    });

    return i18next;
};

export const getI18next = (modules, config) =>
    i18next.use(initReactI18next).init(buildConfig(modules, config));

// i18next.init(buildConfig(modules, config));

export default (modules, config) => buildConfig(modules, config);
